// import React, { useEffect, useState } from "react";
// import CustomTooltip from "../Buttons/CustomTooltip";

// const ViewSummary = ({ viewshow, viewsetShow, jobId, apiEndpoint }) => {
//   const [summaryData, setSummaryData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // State for accordion sections
//   const [openSections, setOpenSections] = useState({
//     metadata: true,
//     components: true,
//     job_name: true,
//     complexity: true,
//     summary: true,
//     runInfo: true, // For SQL
//     sqlComponents: true, // For SQL
//     complexityAnalysis: true, // For SQL
//   });

//   useEffect(() => {
//     const fetchSummaryData = async () => {
//       if (viewshow && jobId) {
//         setLoading(true);
//         setError(null);
//         try {
//           const authToken = sessionStorage.getItem("access_token");
//           const response = await fetch(`${apiEndpoint}/${jobId}`, {
//             headers: {
//               Authorization: `Bearer ${authToken}`,
//             },
//           });

//           if (!response.ok) throw new Error("Failed to fetch summary data");

//           const data = await response.json();
//           setSummaryData(data);
//         } catch (err) {
//           setError(err.message);
//         } finally {
//           setLoading(false);
//         }
//       }
//     };

//     fetchSummaryData();
//   }, [viewshow, jobId, apiEndpoint]);

//   const handleviewClose = () => viewsetShow(false);

//   const toggleSection = (section) => {
//     setOpenSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   if (!viewshow) return null;

//   const renderKeyValuePairs = (data, columns = 2) => {
//     if (!data) return null;

//     const entries = Object.entries(data);
//     if (columns === 1) {
//       return (
//         <div className="row">
//           <div className="col-12">
//             {entries.map(([key, val]) => (
//               <div className="d-flex justify-content-between mb-2" key={key}>
//                 <span style={{ fontSize: "12px", color: "#818283" }}>
//                   <span style={{ color: "#494949" }} className="me-1 fw-medium">
//                     {key}:
//                   </span>
//                   {val !== undefined && val !== null ? val : "N/A"}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     const half = Math.ceil(entries.length / 2);
//     const left = entries.slice(0, half);
//     const right = entries.slice(half);

//     return (
//       <div className="row">
//         <div className="col-6">
//           {left.map(([key, val]) => (
//             <div className="d-flex justify-content-between mb-2" key={key}>
//               <span style={{ fontSize: "12px", color: "#818283" }}>
//                 <span style={{ color: "#494949" }} className="me-1 fw-medium">
//                   {key}:
//                 </span>
//                 {val !== undefined && val !== null ? val : "N/A"}
//               </span>
//             </div>
//           ))}
//         </div>
//         <div className="col-6">
//           {right.map(([key, val]) => (
//             <div className="d-flex justify-content-between mb-2" key={key}>
//               <span style={{ fontSize: "12px", color: "#818283" }}>
//                 <span style={{ color: "#494949" }} className="me-1 fw-medium">
//                   {key}:
//                 </span>
//                 {val !== undefined && val !== null ? val : "N/A"}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   };

//   const renderFilteredKeyValuePairs = (
//     data,
//     excludedKeys = [],
//     columns = 2
//   ) => {
//     if (!data) return null;

//     // Filter out excluded keys
//     const filteredData = Object.fromEntries(
//       Object.entries(data).filter(([key]) => !excludedKeys.includes(key))
//     );

//     return renderKeyValuePairs(filteredData, columns);
//   };
//   const renderSasComplexityTable = (complexity = []) => {
//     if (!complexity || complexity.length === 0) return null;

//     const left = complexity.slice(0, 2);
//     const right = complexity.slice(2);

//     const renderBlock = (item) => {
//       const { Complexity, ...rest } = item;
//       return (
//         <div className="mb-2" key={Complexity}>
//           <div
//             className="fw-semibold"
//             style={{ fontSize: "12px", color: "#494949" }}
//           >
//             {Complexity}
//           </div>
//           {Object.entries(rest).map(([label, value], idx) => (
//             <div
//               className="small"
//               style={{ fontSize: "12px", color: "#818283" }}
//               key={idx}
//             >
//               {label}:{" "}
//               <b>{value !== undefined && value !== null ? value : 0}</b>
//             </div>
//           ))}
//         </div>
//       );
//     };

//     return (
//       <div className="row">
//         <div className="col-6">{left.map(renderBlock)}</div>
//         <div className="col-6">{right.map(renderBlock)}</div>
//       </div>
//     );
//   };

//   const renderSqlComplexityTable = (complexity = {}) => {
//     if (!complexity || Object.keys(complexity).length === 0) return null;

//     // CORRECTED: Map the SQL complexity data to our display format using ACTUAL values
//     const complexityLevels = [
//       {
//         Complexity: "Very Simple",
//         "Files Count": complexity["Files with Very Simple (0-20%)"] || 0,
//       },
//       {
//         Complexity: "Simple",
//         "Files Count": complexity["Files with Simple (20-40%)"] || 0,
//       },
//       {
//         Complexity: "Medium",
//         "Files Count": complexity["Files with Medium (40-60%)"] || 0,
//       },
//       {
//         Complexity: "Complex",
//         "Files Count": complexity["Files with Complex (60-80%)"] || 0,
//       },
//       {
//         Complexity: "Very Complex",
//         "Files Count": complexity["Files with Very Complex (80-100%)"] || 0,
//       },
//     ];

//     const left = complexityLevels.slice(0, 3);
//     const right = complexityLevels.slice(3);

//     return (
//       <div className="row">
//         <div className="col-6">
//           {left.map((item, idx) => (
//             <div className="mb-2" key={idx}>
//               <div
//                 className="fw-semibold"
//                 style={{ fontSize: "12px", color: "#494949" }}
//               >
//                 {item.Complexity}
//               </div>
//               <div
//                 className="small"
//                 style={{ fontSize: "12px", color: "#818283" }}
//               >
//                 Files Count: {item["Files Count"]}
//               </div>
//             </div>
//           ))}
//         </div>
//         <div className="col-6">
//           {right.map((item, idx) => (
//             <div className="mb-2" key={idx}>
//               <div
//                 className="fw-semibold"
//                 style={{ fontSize: "12px", color: "#494949" }}
//               >
//                 {item.Complexity}
//               </div>
//               <div
//                 className="small"
//                 style={{ fontSize: "12px", color: "#818283" }}
//               >
//                 Files Count: {item["Files Count"]}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   };

//   const renderComplexityTable = (complexity = []) => {
//     if (!complexity || complexity.length === 0) return null;

//     const left = complexity.slice(0, 2);
//     const right = complexity.slice(2);

//     return (
//       <div className="row">
//         <div className="col-6">
//           {left.map((item, idx) => (
//             <div className="mb-2" key={idx}>
//               <div
//                 className="fw-semibold"
//                 style={{ fontSize: "12px", color: "#494949" }}
//               >
//                 {item.Complexity}
//               </div>
//               <div
//                 className="small"
//                 style={{ fontSize: "12px", color: "#818283" }}
//               >
//                 Mappings:{" "}
//                 <b>
//                   {item["No of Mappings"] !== undefined &&
//                   item["No of Mappings"] !== null
//                     ? item["No of Mappings"]
//                     : 0}
//                 </b>
//               </div>
//               <div
//                 className="small"
//                 style={{ fontSize: "12px", color: "#818283" }}
//               >
//                 Mapplets: <b>{item["No of Mapplets"] || 0}</b>
//               </div>
//               <div
//                 className="small"
//                 style={{ fontSize: "12px", color: "#818283" }}
//               >
//                 Workflows: <b>{item["No of Workflows"] || 0}</b>
//               </div>
//             </div>
//           ))}
//         </div>
//         <div className="col-6">
//           {right.map((item, idx) => (
//             <div className="mb-2" key={idx}>
//               <div
//                 className="fw-semibold"
//                 style={{ fontSize: "12px", color: "#494949" }}
//               >
//                 {item.Complexity}
//               </div>
//               <div
//                 className="small"
//                 style={{ fontSize: "12px", color: "#818283" }}
//               >
//                 Mappings:{" "}
//                 <b>
//                   {item["No of Mappings"] !== undefined &&
//                   item["No of Mappings"] !== null
//                     ? item["No of Mappings"]
//                     : 0}
//                 </b>
//               </div>
//               <div
//                 className="small"
//                 style={{ fontSize: "12px", color: "#818283" }}
//               >
//                 Mapplets: <b>{item["No of Mapplets"] || 0}</b>
//               </div>
//               <div
//                 className="small"
//                 style={{ fontSize: "12px", color: "#818283" }}
//               >
//                 Workflows: <b>{item["No of Workflows"] || 0}</b>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   };

//   const renderSasView = () => (
//     <div className="row mt-4 pb-2">
//       {/* Metadata */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("metadata")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/Metadata.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 Metadata
//                 <i
//                   className={`mdi ${
//                     openSections.metadata ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div className={`collapse ${openSections.metadata ? "show" : ""}`}>
//               <div className="flot-body">
//                 {renderKeyValuePairs(summaryData.metadata)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Components */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("components")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/components.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 Components
//                 <i
//                   className={`mdi ${
//                     openSections.components ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div
//               className={`collapse ${openSections.components ? "show" : ""}`}
//             >
//               <div className="flot-body">
//                 {renderKeyValuePairs(summaryData.components)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Complexity */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("complexity")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/complexity.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 Complexity
//                 <i
//                   className={`mdi ${
//                     openSections.complexity ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div
//               className={`collapse ${openSections.complexity ? "show" : ""}`}
//             >
//               <div className="flot-body">
//                 {renderSasComplexityTable(summaryData.complexity)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderInformaticaView = () => (
//     <div className="row mt-4 pb-2">
//       {/* Metadata */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("metadata")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/Metadata.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 Metadata
//                 <i
//                   className={`mdi ${
//                     openSections.metadata ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div className={`collapse ${openSections.metadata ? "show" : ""}`}>
//               <div className="flot-body">
//                 {renderKeyValuePairs(summaryData.metadata)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Components */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("components")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/components.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 Components
//                 <i
//                   className={`mdi ${
//                     openSections.components ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div
//               className={`collapse ${openSections.components ? "show" : ""}`}
//             >
//               <div className="flot-body">
//                 {renderKeyValuePairs(summaryData.components)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Complexity */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("complexity")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/complexity.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 Complexity
//                 <i
//                   className={`mdi ${
//                     openSections.complexity ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div
//               className={`collapse ${openSections.complexity ? "show" : ""}`}
//             >
//               <div className="flot-body">
//                 {renderComplexityTable(summaryData.complexity)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderDataStageView = () => {
//     return (
//       <div className="row  pb-2 datastage-summary-view">
//         {/* Job Summary Header */}
//         <div className="col-12 mb-4">
//          <div className="datastage-header-content">
//   <div className="datastage-header-text">
//     <h6 className="datastage-job-title">
//       IBM DataStage Job Summary
//     </h6>
//     <p className="datastage-job-subtitle">
//       High-level analysis of your ETL job run.
//     </p>
    
//   </div>
 
  
//   <div className="datastage-header-close ">
    
//     <CustomTooltip
//       content="Close"
//       placement="left"
//       fallbackPlacements={["top-end", "top"]}
//       offset={[-10, 0]}
//       delayShow={200}
//     >
//       <i
//         onClick={handleviewClose}
//         className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor datastage-close-icon"
//       />
//     </CustomTooltip>
    
//   </div>

  
//    <div className="datastage-header-right" >
//     <div className="datastage-analysis-time ">
//       <span className="datastage-analysis-label">Analysis run:</span>
//       <span className="datastage-analysis-value">2.4s ago</span>
//     </div>
//   </div>
  
// </div>

//          <div className="datastage-source-section">
//   <div className="datastage-source-info">
//     <span className="datastage-source-label">Source:</span>
//     <span className="datastage-source-value">IBM DataStage</span>
//     <span className="datastage-job-name-inline">{summaryData.job_name || "N/A"}</span>
//   </div>
//   <div className="datastage-complexity-line">
//     Very simple complexity
//   </div>
// </div>
          

//           <div className="datastage-pipeline-info">
//             <div className="datastage-pipeline-type">
//               <span className="datastage-etl-badge">ETL pipeline</span>
//               <span className="datastage-load-badge">Incremental load</span>
//             </div>
//             <div className="datastage-last-run">Last run: 12 min ago</div>
//           </div>
//         </div>

//         {/* Job Metrics */}
//         <div className="col-12 mb-4">
//           <div className="datastage-metrics-container">
//             <h6 className="datastage-metrics-title">Job Metrics</h6>
//             <div className="datastage-metrics-grid">
//               <div className="datastage-metric-item">
//                 <div className="datastage-metric-value">18</div>
//                 <div className="datastage-metric-label">Total jobs found</div>
//                 <div className="datastage-metric-subtext">In this project</div>
//               </div>
//               <div className="datastage-metric-item">
//                 <div className="datastage-metric-value">42</div>
//                 <div className="datastage-metric-label">Total stages</div>
//                 <div className="datastage-metric-subtext">
//                   Transform → lookup
//                 </div>
//               </div>
//               <div className="datastage-metric-item">
//                 <div className="datastage-metric-value">5</div>
//                 <div className="datastage-metric-label">Total sources</div>
//                 <div className="datastage-metric-subtext">
//                   Distinct input systems
//                 </div>
//               </div>
//               <div className="datastage-metric-item">
//                 <div className="datastage-metric-value">3</div>
//                 <div className="datastage-metric-label">Total targets</div>
//                 <div className="datastage-metric-subtext">
//                   Warehouse destinations
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Job Summary */}
//         <div className="col-12">
//           <div className="datastage-summary">
//             <h6 className="datastage-summary-title">Job Summary</h6>
//             <div className="datastage-summary-container">
//               <div className=" datastage-complexity-badge">
//                 Low-complexity daily load
//               </div>
//               <p className="datastage-summary-text">
//                 This job reads from 5 source systems, applies light
//                 transformation logic across 42 stages, and writes into 3 target
//                 datasets. Overall structure is linear with no cyclic
//                 dependencies and limited branching, which keeps it easy to
//                 maintain and safe to modify.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderSqlView = () => (
//     <div className="row mt-4 pb-2">
//       {/* Run Information */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("runInfo")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/Metadata.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 Run Information
//                 <i
//                   className={`mdi ${
//                     openSections.runInfo ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div className={`collapse ${openSections.runInfo ? "show" : ""}`}>
//               <div className="flot-body">
//                 {renderFilteredKeyValuePairs(summaryData.metadata, [
//                   "Input Path",
//                 ])}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* SQL Component Summary */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("sqlComponents")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/components.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 SQL Component Summary
//                 <i
//                   className={`mdi ${
//                     openSections.sqlComponents ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div
//               className={`collapse ${openSections.sqlComponents ? "show" : ""}`}
//             >
//               <div className="flot-body">
//                 {renderKeyValuePairs(summaryData.components)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Complexity Analysis */}
//       <div className="col-12 mb-2">
//         <div className="custom-accordion">
//           <div className="card shadow-none ans-float-box flot-body">
//             <div
//               className="flot-head cursor-pointer"
//               onClick={() => toggleSection("complexityAnalysis")}
//             >
//               <h6
//                 className="m-0 font-size-12 fw-bold font-family-dmsans"
//                 style={{ color: "#354258", fontSize: "13px" }}
//               >
//                 <span className="me-2">
//                   <img
//                     src="assets/images/complexity.svg"
//                     style={{
//                       height: "15px",
//                       width: "14px",
//                       marginBottom: "3px",
//                     }}
//                   />
//                 </span>
//                 Complexity Analysis
//                 <i
//                   className={`mdi ${
//                     openSections.complexityAnalysis ? "mdi-minus" : "mdi-plus"
//                   } float-end accor-plus-icon`}
//                   style={{ color: "#354258" }}
//                 ></i>
//               </h6>
//             </div>
//             <div
//               className={`collapse ${
//                 openSections.complexityAnalysis ? "show" : ""
//               }`}
//             >
//               <div className="flot-body">
//                 {renderSqlComplexityTable(summaryData.complexity)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderViewBasedOnSourceType = () => {
//     if (!summaryData?.source_type) return null;

//     const sourceType = summaryData.source_type.toLowerCase();

//     if (sourceType.includes("informatica")) {
//       return renderInformaticaView();
//     } else if (sourceType.includes("datastage")) {
//       return renderDataStageView();
//     } else if (sourceType.includes("sas")) {
//       return renderSasView();
//     } else if (sourceType.includes("sql")) {
//       // ADD THIS LINE
//       return renderSqlView(); // ADD THIS LINE
//     }

//     // Default view for other source types
//     return (
//       <div className="row mt-4 pb-2">
//         <div className="col-12">{renderKeyValuePairs(summaryData, 2)}</div>
//       </div>
//     );
//   };

//   return (
//     <div className="right-bar3 p-3">
//       <style>
//         {`
//           .right-bar3 {
//             display: flex;
//             flex-direction: column;
//             height: 100vh;
//           }
          
//           .right-bar3 .header-fixed {
//             flex-shrink: 0;
//           }
          
//           .right-bar3 .content-container {
//             flex: 1;
//             overflow: hidden;
//             display: flex;
//             flex-direction: column;
//           }
          
//           .right-bar3 .scrollable-content {
//             flex: 1;
//             overflow-y: auto;
//             margin-bottom: 60px; /* Space for the fixed button */
//           }
          
      
          
//           .right-bar3 .custom-tooltip {
//             z-index: 10000 !important;
//             position: fixed !important;
//           }

//           .custom-tooltip[data-popper-placement^='left'] > .react-tooltip-arrow {
//             border-left-color: #e0b8ff !important;
//           }

//           .custom-accordion .card.flot-body {
//             border: 1px solid #E3E3E3 !important;
//             border-radius: 8px !important;
//             margin-bottom: 12px;
//             padding: 0 !important;
//           }

//           .flot-head {
//             padding: 12px 16px !important;
//             background-color: #f9f9f9;
//             border-bottom: 1px solid #E3E3E3;
//           }

//           .flot-body {
//             padding: 12px 16px !important;
//           }
          
//           .cursor-pointer {
//             cursor: pointer;
//           }
//         `}
//       </style>

//       <div className="header-fixed d-flex justify-content-between align-items-center">
//         {/* <h6
//           className="mb-0 fw-medium textfontsizehead"
//           style={{ fontSize: "14px", color: "#354258" }}
//         >
//           Visual Summary
//         </h6> */}
//       </div>

//       <div className="content-container">
//         {loading ? (
//           <div className="scrollable-content mt-4 ps-0 ms-0">
//             <div
//               className="textfontsizehead fw-bold pt-2"
//               style={{ fontSize: "16px" }}
//             >
//               <span
//                 className="loadingStyle"
//                 style={{
//                   height: "24px",
//                   width: "60%",
//                   display: "inline-block",
//                 }}
//               ></span>
//             </div>
//             <div className="accordion" id="accordionExample">
//               {[...Array(3)].map((_, i) => (
//                 <div
//                   className="card mb-1 shadow-none ans-float-box flot-body"
//                   key={i}
//                 >
//                   <div className="flot-head">
//                     <div
//                       className="loadingStyle"
//                       style={{ height: "20px", width: "40%" }}
//                     ></div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ) : error ? (
//           <div className="scrollable-content">
//             <div className="alert alert-danger mt-3">{error}</div>
//           </div>
//         ) : !summaryData ? (
//           <div className="scrollable-content">
//             <div className="alert alert-info mt-3">
//               No summary data available
//             </div>
//           </div>
//         ) : (
//           <div className="scrollable-content  ps-0 ms-0">
//             {/* <div
//               className="textfontsizeone fw-bold pt-2"
//               style={{ fontSize: "16px", color: "#354258" }}
//             >
//               Job Name: {summaryData.job_name || "N/A"}
//             </div> */}

//             {renderViewBasedOnSourceType()}
//           </div>
//         )}
//       </div>

//       <div className="fixed-close-button">
//         <button
//           onClick={handleviewClose}
//           className="btn btn-closebtn custom-button"
//         >
//           Close
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ViewSummary;



import React, { useEffect, useState } from "react";
import CustomTooltip from "../Buttons/CustomTooltip";

const ViewSummary = ({ viewshow, viewsetShow, jobId, apiEndpoint }) => {
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // State for accordion sections
  const [openSections, setOpenSections] = useState({
    metadata: true,
    components: true,
    job_name: true,
    complexity: true,
    summary: true,
     runInfo: true,       // For SQL
  sqlComponents: true, // For SQL
  complexityAnalysis: true ,// For SQL
  migrationCritical: true,    // Add for SSIS
  structure: true             // Add for SSIS
  });

  useEffect(() => {
    const fetchSummaryData = async () => {
      if (viewshow && jobId) {
        setLoading(true);
        setError(null);
        try {
          const authToken = sessionStorage.getItem("access_token");
          const response = await fetch(`${apiEndpoint}/${jobId}`, {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          });

          if (!response.ok) throw new Error("Failed to fetch summary data");

          const data = await response.json();
          setSummaryData(data);
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchSummaryData();
  }, [viewshow, jobId, apiEndpoint]);

  const handleviewClose = () => viewsetShow(false);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  if (!viewshow) return null;

  const renderKeyValuePairs = (data, columns = 2) => {
    if (!data) return null;

    const entries = Object.entries(data);
    if (columns === 1) {
      return (
        <div className="row">
          <div className="col-12">
            {entries.map(([key, val]) => (
              <div className="d-flex justify-content-between mb-2" key={key}>
                <span style={{ fontSize: "12px", color: "#818283" }}>
                  <span style={{ color: "#494949" }} className="me-1 fw-medium">
                    {key}:
                  </span>
                {val !== undefined && val !== null ? val : "N/A"} 
                </span>
              </div>
            ))}
          </div>
        </div>
      );
    }

    const half = Math.ceil(entries.length / 2);
    const left = entries.slice(0, half);
    const right = entries.slice(half);

    return (
      <div className="row">
        <div className="col-6">
          {left.map(([key, val]) => (
            <div className="d-flex justify-content-between mb-2" key={key}>
              <span style={{ fontSize: "12px", color: "#818283" }}>
                <span style={{ color: "#494949" }} className="me-1 fw-medium">
                  {key}:
                </span>
                {val !== undefined && val !== null ? val : "N/A"}
              </span>
            </div>
          ))}
        </div>
        <div className="col-6">
          {right.map(([key, val]) => (
            <div className="d-flex justify-content-between mb-2" key={key}>
              <span style={{ fontSize: "12px", color: "#818283" }}>
                <span style={{ color: "#494949" }} className="me-1 fw-medium">
                  {key}:
                </span>
                {val !== undefined && val !== null ? val : "N/A"}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderFilteredKeyValuePairs = (data, excludedKeys = [], columns = 2) => {
  if (!data) return null;
  
  // Filter out excluded keys
  const filteredData = Object.fromEntries(
    Object.entries(data).filter(([key]) => !excludedKeys.includes(key))
  );
  
  return renderKeyValuePairs(filteredData, columns);
};
  const renderSasComplexityTable = (complexity = []) => {
    if (!complexity || complexity.length === 0) return null;

    const left = complexity.slice(0, 2);
    const right = complexity.slice(2);

    const renderBlock = (item) => {
      const { Complexity, ...rest } = item;
      return (
        <div className="mb-2" key={Complexity}>
          <div
            className="fw-semibold"
            style={{ fontSize: "12px", color: "#494949" }}
          >
            {Complexity}
          </div>
          {Object.entries(rest).map(([label, value], idx) => (
            <div
              className="small"
              style={{ fontSize: "12px", color: "#818283" }}
              key={idx}
            >
             {label}: <b>{value !== undefined && value !== null ? value : 0}</b>
            </div>
          ))}
        </div>
      );
    };

    return (
      <div className="row">
        <div className="col-6">{left.map(renderBlock)}</div>
        <div className="col-6">{right.map(renderBlock)}</div>
      </div>
    );
  };

  const renderSqlComplexityTable = (complexity = {}) => {
    if (!complexity || Object.keys(complexity).length === 0) return null;
  
    // UPDATED: Keys now match the exact strings from the Excel "Complexity Split" column
    const complexityLevels = [
      { 
        label: "Very Simple", 
        value: complexity["Very Simple (0-20%)"] || "0"
      },
      { 
        label: "Simple", 
        value: complexity["Simple (20-40%)"] || "0"
      },
      { 
        label: "Medium", 
        value: complexity["Medium (40-60%)"] || "0"
      },
      { 
        label: "Complex", 
        value: complexity["Complex (60-80%)"] || "0"
      },
      { 
        label: "Very Complex", 
        value: complexity["Very Complex (80-100%)"] || "0"
      }
    ];
  
    const left = complexityLevels.slice(0, 3);
    const right = complexityLevels.slice(3);
  
    return (
      <div className="row">
        <div className="col-6">
          {left.map((item, idx) => (
            <div className="mb-2" key={idx}>
              <div className="fw-semibold" style={{ fontSize: "12px", color: "#494949" }}>
                {item.label}
              </div>
              {/* Value is like "95 files (100.0%)", so we display it directly */}
              <div className="small" style={{ fontSize: "12px", color: "#818283" }}>
                {item.value}
              </div>
            </div>
          ))}
        </div>
        <div className="col-6">
          {right.map((item, idx) => (
            <div className="mb-2" key={idx}>
              <div className="fw-semibold" style={{ fontSize: "12px", color: "#494949" }}>
                {item.label}
              </div>
              <div className="small" style={{ fontSize: "12px", color: "#818283" }}>
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderComplexityTable = (complexity = []) => {
    if (!complexity || complexity.length === 0) return null;

    const left = complexity.slice(0, 2);
    const right = complexity.slice(2);

    return (
      <div className="row">
        <div className="col-6">
          {left.map((item, idx) => (
            <div className="mb-2" key={idx}>
              <div
                className="fw-semibold"
                style={{ fontSize: "12px", color: "#494949" }}
              >
                {item.Complexity}
              </div>
              <div
                className="small"
                style={{ fontSize: "12px", color: "#818283" }}
              >
               Mappings: <b>{item["No of Mappings"] !== undefined && item["No of Mappings"] !== null ? item["No of Mappings"] : 0}</b>
              </div>
              <div
                className="small"
                style={{ fontSize: "12px", color: "#818283" }}
              >
                Mapplets: <b>{item["No of Mapplets"] || 0}</b>
              </div>
              <div
                className="small"
                style={{ fontSize: "12px", color: "#818283" }}
              >
                Workflows: <b>{item["No of Workflows"] || 0}</b>
              </div>
            </div>
          ))}
        </div>
        <div className="col-6">
          {right.map((item, idx) => (
            <div className="mb-2" key={idx}>
              <div
                className="fw-semibold"
                style={{ fontSize: "12px", color: "#494949" }}
              >
                {item.Complexity}
              </div>
              <div
                className="small"
                style={{ fontSize: "12px", color: "#818283" }}
              >
               Mappings: <b>{item["No of Mappings"] !== undefined && item["No of Mappings"] !== null ? item["No of Mappings"] : 0}</b>
              </div>
              <div
                className="small"
                style={{ fontSize: "12px", color: "#818283" }}
              >
                Mapplets: <b>{item["No of Mapplets"] || 0}</b>
              </div>
              <div
                className="small"
                style={{ fontSize: "12px", color: "#818283" }}
              >
                Workflows: <b>{item["No of Workflows"] || 0}</b>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderSasView = () => (
    <div className="row mt-4 pb-2">
      {/* Metadata */}
      <div className="col-12 mb-2">
        <div className="custom-accordion">
          <div className="card shadow-none ans-float-box flot-body">
            <div
              className="flot-head cursor-pointer"
              onClick={() => toggleSection("metadata")}
            >
              <h6
                className="m-0 font-size-12 fw-bold font-family-dmsans"
                style={{ color: "#354258", fontSize: "13px" }}
              >
                <span className="me-2">
                  <img
                    src="assets/images/Metadata.svg"
                    style={{
                      height: "15px",
                      width: "14px",
                      marginBottom: "3px"
                    }}
                  />
                </span>
                Metadata
                <i
                  className={`mdi ${
                    openSections.metadata ? "mdi-minus" : "mdi-plus"
                  } float-end accor-plus-icon`}
                  style={{ color: "#354258" }}
                ></i>
              </h6>
            </div>
            <div className={`collapse ${openSections.metadata ? "show" : ""}`}>
              <div className="flot-body">
               {renderKeyValuePairs(summaryData.metadata)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Components */}
      <div className="col-12 mb-2">
        <div className="custom-accordion">
          <div className="card shadow-none ans-float-box flot-body">
            <div
              className="flot-head cursor-pointer"
              onClick={() => toggleSection("components")}
            >
              <h6
                className="m-0 font-size-12 fw-bold font-family-dmsans"
                style={{ color: "#354258", fontSize: "13px" }}
              >
                <span className="me-2">
                  <img
                    src="assets/images/components.svg"
                    style={{
                      height: "15px",
                      width: "14px",
                      marginBottom: "3px"
                    }}
                  />
                </span>
                Components
                <i
                  className={`mdi ${
                    openSections.components ? "mdi-minus" : "mdi-plus"
                  } float-end accor-plus-icon`}
                  style={{ color: "#354258" }}
                ></i>
              </h6>
            </div>
            <div className={`collapse ${openSections.components ? "show" : ""}`}>
              <div className="flot-body">
                {renderKeyValuePairs(summaryData.components)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Complexity */}
      <div className="col-12 mb-2">
        <div className="custom-accordion">
          <div className="card shadow-none ans-float-box flot-body">
            <div
              className="flot-head cursor-pointer"
              onClick={() => toggleSection("complexity")}
            >
              <h6
                className="m-0 font-size-12 fw-bold font-family-dmsans"
                style={{ color: "#354258", fontSize: "13px" }}
              >
                <span className="me-2">
                  <img
                    src="assets/images/complexity.svg"
                    style={{
                      height: "15px",
                      width: "14px",
                      marginBottom: "3px"
                    }}
                  />
                </span>
                Complexity
                <i
                  className={`mdi ${
                    openSections.complexity ? "mdi-minus" : "mdi-plus"
                  } float-end accor-plus-icon`}
                  style={{ color: "#354258" }}
                ></i>
              </h6>
            </div>
            <div className={`collapse ${openSections.complexity ? "show" : ""}`}>
              <div className="flot-body">
                {renderSasComplexityTable(summaryData.complexity)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderInformaticaView = () => (
    <div className="row mt-4 pb-2">
      {/* Metadata */}
      <div className="col-12 mb-2">
        <div className="custom-accordion">
          <div className="card shadow-none ans-float-box flot-body">
            <div
              className="flot-head cursor-pointer"
              onClick={() => toggleSection("metadata")}
            >
              <h6
                className="m-0 font-size-12 fw-bold font-family-dmsans"
                style={{ color: "#354258", fontSize: "13px" }}
              >
                <span className="me-2">
                  <img
                    src="assets/images/Metadata.svg"
                    style={{
                      height: "15px",
                      width: "14px",
                      marginBottom:"3px"
                    }}
                  />
                </span>
                Metadata
                <i
                  className={`mdi ${
                    openSections.metadata ? "mdi-minus" : "mdi-plus"
                  } float-end accor-plus-icon`}
                  style={{ color: "#354258" }}
                ></i>
              </h6>
            </div>
            <div className={`collapse ${openSections.metadata ? "show" : ""}`}>
              <div className="flot-body">
                {renderKeyValuePairs(summaryData.metadata)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Components */}
      <div className="col-12 mb-2">
        <div className="custom-accordion">
          <div className="card shadow-none ans-float-box flot-body">
            <div
              className="flot-head cursor-pointer"
              onClick={() => toggleSection("components")}
            >
              <h6
                className="m-0 font-size-12 fw-bold font-family-dmsans"
                style={{ color: "#354258", fontSize: "13px" }}
              >
                <span className="me-2">
                  <img
                    src="assets/images/components.svg"
                    style={{
                      height: "15px",
                      width: "14px",
                      marginBottom:"3px"
                    }}
                  />
                </span>
                Components
                <i
                  className={`mdi ${
                    openSections.components ? "mdi-minus" : "mdi-plus"
                  } float-end accor-plus-icon`}
                  style={{ color: "#354258" }}
                ></i>
              </h6>
            </div>
            <div
              className={`collapse ${openSections.components ? "show" : ""}`}
            >
              <div className="flot-body">
                {renderKeyValuePairs(summaryData.components)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Complexity */}
      <div className="col-12 mb-2">
        <div className="custom-accordion">
          <div className="card shadow-none ans-float-box flot-body">
            <div
              className="flot-head cursor-pointer"
              onClick={() => toggleSection("complexity")}
            >
              <h6
                className="m-0 font-size-12 fw-bold font-family-dmsans"
                style={{ color: "#354258", fontSize: "13px" }}
              >
                <span className="me-2">
                  <img
                    src="assets/images/complexity.svg"
                    style={{
                      height: "15px",
                      width: "14px",
                      marginBottom:"3px"
                    }}
                  />
                </span>
                Complexity
                <i
                  className={`mdi ${
                    openSections.complexity ? "mdi-minus" : "mdi-plus"
                  } float-end accor-plus-icon`}
                  style={{ color: "#354258" }}
                ></i>
              </h6>
            </div>
            <div
              className={`collapse ${openSections.complexity ? "show" : ""}`}
            >
              <div className="flot-body">
                {renderComplexityTable(summaryData.complexity)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderDataStageView = () => {
    // Create a summary object from the response data, excluding source_type and job_name
    const summary = {...summaryData};
    delete summary.source_type;
    delete summary.job_name;

    return (
      <div className="row mt-4 pb-2">
        <div className="col-12 mb-2">
          <div className="custom-accordion">
            <div className="card shadow-none ans-float-box flot-body">
              <div
                className="flot-head cursor-pointer"
                onClick={() => toggleSection("summary")}
              >
                <h6
                  className="m-0 font-size-12 fw-bold font-family-dmsans"
                  style={{ color: "#354258", fontSize: "13px" }}
                >
                  <span className=" me-2">
                    <img
                      src="assets/images/summary.svg"
                      style={{
                        height: "15px",
                        width: "14px",
                        marginBottom:"3px"
                      }}
                    />
                  </span>
                  Summary
                  <i
                    className={`mdi ${
                      openSections.summary ? "mdi-minus" : "mdi-plus"
                    } float-end accor-plus-icon`}
                    style={{ color: "#354258" }}
                  ></i>
                </h6>
              </div>
              <div className={`collapse ${openSections.summary ? "show" : ""}`}>
                <div className="flot-body">
                  {renderKeyValuePairs(summary, 2)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderSqlView = () => (
  <div className="row mt-4 pb-2">
    {/* Run Information */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("runInfo")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/Metadata.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Run Information
              <i
                className={`mdi ${
                  openSections.runInfo ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.runInfo ? "show" : ""}`}>
            <div className="flot-body">
               {renderFilteredKeyValuePairs(summaryData.metadata, ["Input Path"])}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* SQL Component Summary */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("sqlComponents")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/components.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              SQL Component Summary
              <i
                className={`mdi ${
                  openSections.sqlComponents ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.sqlComponents ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.components)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Complexity Analysis */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("complexityAnalysis")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/complexity.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Complexity Analysis
              <i
                className={`mdi ${
                  openSections.complexityAnalysis ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.complexityAnalysis ? "show" : ""}`}>
            <div className="flot-body">
              {renderSqlComplexityTable(summaryData.complexity)}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const renderSSISView = () => (
  <div className="row mt-4 pb-2">
    {/* Metadata */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("metadata")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/Metadata.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Metadata
              <i
                className={`mdi ${
                  openSections.metadata ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.metadata ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.metadata, 1)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Migration Critical */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("migrationCritical")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/components.svg"  // You might want a different icon
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Migration Critical
              <i
                className={`mdi ${
                  openSections.migrationCritical ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.migrationCritical ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.migration_critical, 1)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Structure */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("structure")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/components.svg"  // You might want a different icon
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Structure
              <i
                className={`mdi ${
                  openSections.structure ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.structure ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.structure, 1)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Components */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("components")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/components.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Components
              <i
                className={`mdi ${
                  openSections.components ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.components ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.components, 1)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Complexity */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("complexity")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/complexity.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Complexity
              <i
                className={`mdi ${
                  openSections.complexity ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.complexity ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.complexity, 1)}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const renderAlteryxView = () => (
  <div className="row mt-4 pb-2">
    {/* Metadata */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("metadata")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/Metadata.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Metadata
              <i
                className={`mdi ${
                  openSections.metadata ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.metadata ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.metadata, 1)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Components */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("components")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/components.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Components
              <i
                className={`mdi ${
                  openSections.components ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.components ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.components, 2)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Complexity */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("complexity")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/complexity.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                />
              </span>
              Complexity
              <i
                className={`mdi ${
                  openSections.complexity ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.complexity ? "show" : ""}`}>
            <div className="flot-body">
              {/* Alteryx complexity is an object, not array */}
              {summaryData.complexity && Object.keys(summaryData.complexity).length > 0 ? (
  <div className="row">
    {/* Left column - first 3 items */}
    <div className="col-6">
      {Object.entries(summaryData.complexity)
        .slice(0, 3)
        .map(([key, val]) => (
          <div className="d-flex justify-content-between mb-2" key={key}>
            <span style={{ fontSize: "12px", color: "#818283" }}>
              <span style={{ color: "#494949" }} className="me-1 fw-medium">
                {key}:
              </span>
              {val !== undefined && val !== null ? val : "N/A"} 
            </span>
          </div>
        ))}
    </div>
    
    {/* Right column - remaining items */}
    <div className="col-6">
      {Object.entries(summaryData.complexity)
        .slice(3)
        .map(([key, val]) => (
          <div className="d-flex justify-content-between mb-2" key={key}>
            <span style={{ fontSize: "12px", color: "#818283" }}>
              <span style={{ color: "#494949" }} className="me-1 fw-medium">
                {key}:
              </span>
              {val !== undefined && val !== null ? val : "N/A"} 
            </span>
          </div>
        ))}
    </div>
  </div>
) : (
  <div style={{ fontSize: "12px", color: "#818283" }}>
    No complexity data available
  </div>
)}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const renderTableauView = () => (
  <div className="row mt-4 pb-2">
    {/* Metadata */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("metadata")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/Metadata.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                  alt="Metadata"
                />
              </span>
              Metadata
              <i
                className={`mdi ${
                  openSections.metadata ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.metadata ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.metadata, 1)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Components */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("components")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/components.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                  alt="Components"
                />
              </span>
              Components
              <i
                className={`mdi ${
                  openSections.components ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.components ? "show" : ""}`}>
            <div className="flot-body">
              {renderKeyValuePairs(summaryData.components, 2)}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Complexity */}
    <div className="col-12 mb-2">
      <div className="custom-accordion">
        <div className="card shadow-none ans-float-box flot-body">
          <div
            className="flot-head cursor-pointer"
            onClick={() => toggleSection("complexity")}
          >
            <h6
              className="m-0 font-size-12 fw-bold font-family-dmsans"
              style={{ color: "#354258", fontSize: "13px" }}
            >
              <span className="me-2">
                <img
                  src="assets/images/complexity.svg"
                  style={{
                    height: "15px",
                    width: "14px",
                    marginBottom: "3px"
                  }}
                  alt="Complexity"
                />
              </span>
              Complexity breakdown
              <i
                className={`mdi ${
                  openSections.complexity ? "mdi-minus" : "mdi-plus"
                } float-end accor-plus-icon`}
                style={{ color: "#354258" }}
              ></i>
            </h6>
          </div>
          <div className={`collapse ${openSections.complexity ? "show" : ""}`}>
            <div className="flot-body">
              {summaryData.complexity && Object.keys(summaryData.complexity).length > 0 ? (
                <div className="row">
                  <div className="col-6">
                    {Object.entries(summaryData.complexity)
                      .slice(0, 3)
                      .map(([key, val]) => (
                        <div className="d-flex justify-content-between mb-2" key={key}>
                          <span style={{ fontSize: "12px", color: "#818283" }}>
                            <span style={{ color: "#494949" }} className="me-1 fw-medium">
                              {key}:
                            </span>
                            {val !== undefined && val !== null ? val : "0"}
                          </span>
                        </div>
                      ))}
                  </div>
                  <div className="col-6">
                    {Object.entries(summaryData.complexity)
                      .slice(3)
                      .map(([key, val]) => (
                        <div className="d-flex justify-content-between mb-2" key={key}>
                          <span style={{ fontSize: "12px", color: "#818283" }}>
                            <span style={{ color: "#494949" }} className="me-1 fw-medium">
                              {key}:
                            </span>
                            {val !== undefined && val !== null ? val : "0"}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              ) : (
                <div style={{ fontSize: "12px", color: "#818283" }}>
                  No complexity data available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

  const renderViewBasedOnSourceType = () => {
    if (!summaryData?.source_type) return null;
    
    const sourceType = summaryData.source_type.toLowerCase();
    
    if (sourceType.includes("informatica")) {
      return renderInformaticaView();
    } else if (sourceType.includes("datastage")) {
      return renderDataStageView();
    } else if (sourceType.includes("sas")) {
      return renderSasView();
    }
    else if (sourceType.includes("sql")) {  // ADD THIS LINE
    return renderSqlView();                  // ADD THIS LINE
  }
  else if (sourceType.includes("ssis")) {  // Add this condition
    return renderSSISView();
  }
  else if (sourceType.includes("alteryx")) {  // Add this condition
    return renderAlteryxView();
  }
  else if (sourceType.includes("tableau")) {
    return renderTableauView();
  }
  
    
    // Default view for other source types
    return (
      <div className="row mt-4 pb-2">
        <div className="col-12">
          {renderKeyValuePairs(summaryData, 2)}
        </div>
      </div>
    );
  };

  return (
    <div className="right-bar3 p-3">
      <style>
        {`
          .right-bar3 {
            display: flex;
            flex-direction: column;
            height: 100vh;
          }
          
          .right-bar3 .header-fixed {
            flex-shrink: 0;
          }
          
          .right-bar3 .content-container {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
          }
          
          .right-bar3 .scrollable-content {
            flex: 1;
            overflow-y: auto;
            margin-bottom: 60px; /* Space for the fixed button */
          }
          
      
          
          .right-bar3 .custom-tooltip {
            z-index: 10000 !important;
            position: fixed !important;
          }

          .custom-tooltip[data-popper-placement^='left'] > .react-tooltip-arrow {
            border-left-color: #e0b8ff !important;
          }

          .custom-accordion .card.flot-body {
            border: 1px solid #E3E3E3 !important;
            border-radius: 8px !important;
            margin-bottom: 12px;
            padding: 0 !important;
          }

          .flot-head {
            padding: 12px 16px !important;
            background-color: #f9f9f9;
            border-bottom: 1px solid #E3E3E3;
          }

          .flot-body {
            padding: 12px 16px !important;
          }
          
          .cursor-pointer {
            cursor: pointer;
          }
        `}
      </style>

      <div className="header-fixed d-flex justify-content-between align-items-center">
        <h6
          className="mb-0 fw-medium textfontsizehead"
          style={{ fontSize: "14px", color: "#354258" }}
        >
          Visual Summary
        </h6>
        <div style={{ position: "relative", zIndex: 10 }}>
          <CustomTooltip
            content="Close"
            placement="left"
            fallbackPlacements={["top-end", "top"]}
            offset={[-10, 0]}
            delayShow={200}
          >
            <i
              onClick={handleviewClose}
              className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor"
            />
          </CustomTooltip>
        </div>
      </div>

      <div className="content-container">
        {loading ? (
          <div className="scrollable-content mt-4 ps-0 ms-0">
            <div
              className="textfontsizehead fw-bold pt-2"
              style={{ fontSize: "16px" }}
            >
              <span
                className="loadingStyle"
                style={{
                  height: "24px",
                  width: "60%",
                  display: "inline-block",
                }}
              ></span>
            </div>
            <div className="accordion" id="accordionExample">
              {[...Array(3)].map((_, i) => (
                <div
                  className="card mb-1 shadow-none ans-float-box flot-body"
                  key={i}
                >
                  <div className="flot-head">
                    <div
                      className="loadingStyle"
                      style={{ height: "20px", width: "40%" }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : error ? (
          <div className="scrollable-content">
            <div className="alert alert-danger mt-3">{error}</div>
          </div>
        ) : !summaryData ? (
          <div className="scrollable-content">
            <div className="alert alert-info mt-3">No summary data available</div>
          </div>
        ) : (
          <div className="scrollable-content mt-2 ps-0 ms-0">
            <div
              className="textfontsizeone fw-bold pt-2"
              style={{ fontSize: "16px", color: "#354258" }}
            >
              Job Name: {summaryData.job_name || "N/A"}
            </div>

            {renderViewBasedOnSourceType()}
          </div>
        )}
      </div>

      <div className="fixed-close-button">
        <button
          onClick={handleviewClose}
          className="btn btn-closebtn custom-button"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ViewSummary;